/**
 * Password Protection Form Enhancement
 * Mejora la UX del formulario de contraseña con validación y feedback visual
 */

document.addEventListener('DOMContentLoaded', function() {
    const passwordForm = document.querySelector('.password-form');

    if (!passwordForm) return;

    const passwordInput = passwordForm.querySelector('input[type="password"]');
    const submitButton = passwordForm.querySelector('button[type="submit"]');
    const wrapper = document.querySelector('.password-protection-wrapper');

    // Focus automático en el input
    if (passwordInput) {
        setTimeout(() => {
            passwordInput.focus();
        }, 500);
    }

    // Validación en tiempo real
    if (passwordInput) {
        passwordInput.addEventListener('input', function() {
            const value = this.value.trim();

            if (value.length > 0) {
                submitButton.disabled = false;
                submitButton.style.opacity = '1';
            } else {
                submitButton.disabled = true;
                submitButton.style.opacity = '0.6';
            }
        });

        // Desabilitar submit si está vacío inicialmente
        if (passwordInput.value.trim() === '') {
            submitButton.disabled = true;
            submitButton.style.opacity = '0.6';
        }
    }

    // Estado de carga al enviar
    passwordForm.addEventListener('submit', function(e) {
        const password = passwordInput.value.trim();

        if (password === '') {
            e.preventDefault();
            passwordInput.focus();
            passwordInput.classList.add('shake');

            setTimeout(() => {
                passwordInput.classList.remove('shake');
            }, 500);

            return;
        }

        // Agregar estado de carga
        submitButton.disabled = true;
        submitButton.style.cursor = 'wait';
        const originalText = submitButton.textContent;
        submitButton.textContent = 'Verificando...';

        if (wrapper) {
            wrapper.classList.add('is-loading');
        }

        // Si hay error, restaurar después de 3 segundos
        setTimeout(() => {
            submitButton.disabled = false;
            submitButton.style.cursor = 'pointer';
            submitButton.textContent = originalText;

            if (wrapper) {
                wrapper.classList.remove('is-loading');
            }
        }, 3000);
    });

    // Efecto de shake para errores
    const style = document.createElement('style');
    style.textContent = `
        @keyframes shake {
            0%, 100% { transform: translateX(0); }
            10%, 30%, 50%, 70%, 90% { transform: translateX(-10px); }
            20%, 40%, 60%, 80% { transform: translateX(10px); }
        }

        .shake {
            animation: shake 0.5s;
            border-color: #dc3545 !important;
        }
    `;
    document.head.appendChild(style);

    // Mostrar/Ocultar contraseña (botón toggle)
    const togglePasswordBtn = document.createElement('button');
    togglePasswordBtn.type = 'button';
    togglePasswordBtn.className = 'absolute right-[2.4rem] top-1/2 -translate-y-1/2 text-[#999999] hover:text-[#FF6B35] transition-colors duration-300 z-10';
    togglePasswordBtn.innerHTML = `
        <svg class="w-[2rem] h-[2rem] show-password" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
        </svg>
        <svg class="w-[2rem] h-[2rem] hide-password hidden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path>
        </svg>
    `;

    const inputWrapper = passwordInput.parentElement;
    const existingIcon = inputWrapper.querySelector('div');
    if (existingIcon) {
        existingIcon.remove();
    }
    inputWrapper.appendChild(togglePasswordBtn);

    togglePasswordBtn.addEventListener('click', function() {
        const showIcon = this.querySelector('.show-password');
        const hideIcon = this.querySelector('.hide-password');

        if (passwordInput.type === 'password') {
            passwordInput.type = 'text';
            showIcon.classList.add('hidden');
            hideIcon.classList.remove('hidden');
        } else {
            passwordInput.type = 'password';
            showIcon.classList.remove('hidden');
            hideIcon.classList.add('hidden');
        }

        passwordInput.focus();
    });

    // Detección de errores de WordPress
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('action') === 'postpass' || document.querySelector('.post-password-message')) {
        passwordInput.classList.add('shake');
        passwordInput.focus();

        setTimeout(() => {
            passwordInput.classList.remove('shake');
        }, 500);
    }
});
